import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/Theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/app/components/nav_bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/adaptV4Theme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/styled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/esm/styles/ThemeProviderWithVars.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/useThemeProps.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/styled-engine/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/createContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/createBox/createBox.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/cssVars/createCssVarsProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Grid/createGrid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/RtlProvider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Stack/createStack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useTheme/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeProps/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeWithoutDefault/useThemeWithoutDefault.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans_Thai\",\"arguments\":[{\"variable\":\"--font-noto\",\"subsets\":[\"thai\"]}],\"variableName\":\"noto\"}");
